module.exports = __webpack_public_path__ + "img/vector_presession.bd8afbf6.svg";